import React, { FunctionComponent } from 'react'
import {ResponsiveButton} from './style'
import Spinner from '../Spinner';

type MainButtonProps = {
    color?: string,
    secondary?: boolean,
    disabled?: boolean,
    loading?: boolean,
}

const MainButton:FunctionComponent<MainButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>> = ({ color, secondary, disabled, loading = false, ...props}) => {
    return (
        <ResponsiveButton color={color} secondary={secondary} disabled={disabled} {...props}>
            { loading ? <Spinner color={'#fff'} size="19px"  /> : props.children}
        </ResponsiveButton>
    )
}

export default MainButton
